import React, {Component} from 'react'
import {connect} from 'react-redux'
import Navigation from "./navigation";

function mapStateToProps(state) {
    return {
        // videoRoom: state.videoRoom,
        // entranceUrl: state.entranceUrl
    }
}

function mapDispatchToProps(dispatch, ownProps) {
    return {}
}

class App extends Component {
    render() {
        return (
            <React.Fragment>
                <Navigation />
            </React.Fragment>
        )
    }
}

export default (connect(mapStateToProps, mapDispatchToProps)(App));
